/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from 'react';
// import { NextSeo } from 'next-seo';
import { NextRouter, withRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { BASE_URL, EASING_VALUE, SEO_INFO } from 'libs/constants';
import { Layout } from 'components/templates/layout';
import { InView } from 'react-intersection-observer';
import { motion, useTransform, useViewportScroll } from 'framer-motion';
import { Container } from 'components/organisms/container';
import { Row } from 'components/organisms/row';
import { Col } from 'components/organisms/col';
import { MaskImage } from 'components/atoms/mask-image';
import { useMediaQuery } from 'libs/use-media-query';
import { Heading } from 'components/atoms/heading';
import Link from 'next/link';
import { BackButton } from 'components/atoms/back-button';
import { mapModifiers } from 'libs/component';

interface CaseStudyPageProps {
  router: NextRouter;
  lang?: string;
}

const relatedProducts = [
  {
    slug: 'rtgs',
    title: 'Real Time Gross Settlement (RTGS)',
  },
  {
    slug: 'csd',
    title: 'Central Securities Depository (CSD)',
  },
  {
    slug: 'rtp',
    title: 'Real-Time Payments System (RTP)',
  },
  {
    slug: 'ach-bp',
    title: 'ACH Bulk Payment (ACH-BP)',
  },
  {
    slug: 'cts',
    title: 'Cheque Trancation System (CTS)',
  },
  {
    slug: 'gateway',
    title: 'Gateway',
  },
  {
    slug: 'non-functional',
    title: 'Non-functional specification',
  },
];

const effortList = [
  {
    image: '/images/case-study/effort-1.svg',
    imageSP: '/images/case-study/effort-sp-1.svg',
    title: 'Implementation The Overall Design to Achieve Coordination with Existing Systems.',
    items: [
      'Conducted interactive preliminary research to clarify the country’s financial policies and regulations, compliance with domestic market needs, and the country’s proprietary specifications, and then implemented the overall design to achieve coordination with existing systems.',
      'Designed systems that not only solve short-term problems, but also consider the future, such as ISO 20022 consulting & implementation to implement interoperability that will allow many users to connect in the future.',
    ],
  },
  {
    image: '/images/case-study/effort-2.svg',
    imageSP: '/images/case-study/effort-sp-2.svg',
    title: 'Quick and Flexible Delivery of Components That Match The Country’s Requirements.',
    items: [
      'Achieved fast development using modern methods and production technologies, such as automation, and agile.',
      'Taken resilient action, even in the face of the covid-19 situation, and complete projects on time, completely remotely.',
    ],
  },
  {
    image: '/images/case-study/effort-3.svg',
    imageSP: '/images/case-study/effort-sp-3.svg',
    title: 'Trusted Support to Promote Maximum Utilization of The Installed Infrastructure.',
    items: [
      'Helped customers improve their understanding of the system by approaching their literacy and visualizing the specifications.',
      'Support proactively for all stakeholder communication conducted by the customer in order to promote the utilization of the installed infrastructure. For ISO20022 implementation on financial institute side, we provided extensive follow-up services from development to the connection test phase.',
      'Provided generous local maintenance services by local professionals for the total system, from Application layer to infrastructure layer.',
    ],
  },
];

const effectList = [
  {
    image: '/images/case-study/effect-1.svg',
    imageSP: '/images/case-study/effect-sp-1.svg',
    title: 'Central Bank',
    description: `The implementation of various solutions such as advanced RTGS, ACH, CSD, etc., has enabled us to conduct sophisticated liquidity management in compliance with FMI principles, further reducing settlement risks.<br/>
    <br/>
    In addition to the standard security features such as encryption and two-factor authentication, we have also prepared a DR environment in the event of a disaster at the data center. This enables business continuity even in the event of a disaster, and supports stable running of the financial system.`,
  },
  {
    image: '/images/case-study/effect-2.svg',
    imageSP: '/images/case-study/effect-sp-2.svg',
    title: 'Financial Institutes',
    description: `Financial Institutes are now able to connect their core banking systems to the central bank system via STP, which enables them to automatically transmit large volumes of transaction data from the FI side to the central bank system. In addition, as the introduction of CTS has made it possible to handle checks as digital data, financial institutes have no need to transport checks physically. In this way, financial institutes have been able to get the benefits of preventing erroneous entries and improving work efficiency. As a result, the efficiency of interbank payment & settlement has been further enhanced.`,
  },
];

/* const preloadList = [
  { rel: 'preload', href: '/images/home/case-study.jpg', type: 'image/jpg', as: 'image', media: '(max-width: 768px)' },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (max-width: 768px)',
  },
  { rel: 'preload', href: '/images/home/case-study.jpg', type: 'image/jpg', as: 'image', media: '(min-width: 769px)' },
  {
    rel: 'preload',
    href: '/images/home/case-study@2x.jpg',
    type: 'image/jpg',
    as: 'image',
    media: '(-webkit-min-device-pixel-ratio: 2), (min-width: 769px)',
  },
  { rel: 'preload', href: '/images/case-study/effort-1.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/case-study/effort-2.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/case-study/effort-3.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/case-study/effect-1.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/case-study/effect-2.svg', type: 'image/svg+xml', as: 'image' },
  { rel: 'preload', href: '/images/logos/graph.svg', type: 'image/svg+xml', as: 'image' },
]; */

const CaseStudyPage: React.FC<CaseStudyPageProps> = () => {
  const PAGE_KEY = 'CASE_STUDY_ASEAN';
  const PAGE_SEO_INFO = (SEO_INFO as any)[PAGE_KEY] as any;
  const PAGE_URL = `${BASE_URL}/case-study`;

  const isSP = useMediaQuery('(max-width: 768px)');
  const { scrollY } = useViewportScroll();
  const [pageScrollY, setPageScrollY] = useState(0);
  const [sectionDimensions, setSectionDimensions] = useState({
    head: 712,
    intro: 534,
    background: 744,
    effort: 1763,
    effect: 1282,
    highlight: 548,
    caseStudy: 720,
  });
  const headSectionRef = useRef(null);
  const introSectionRef = useRef(null);
  const backgroundSectionRef = useRef(null);
  const effortSectionRef = useRef(null);
  const effectSectionRef = useRef(null);
  const highlightSectionRef = useRef(null);
  const caseStudySectionRef = useRef(null);
  /* const [sectionPictureReveals, setSectionPictureReveals] = useState({
    head: false,
    intro: false,
    background: false,
    effort: false,
    effect: false,
    highlight: false,
    caseStudy: false,
  }); */

  /* const viewPage = (path: string) => {
    router.push(path, path, { scroll: true });
  }; */

  useEffect(() => {
    scrollY.onChange(v => setPageScrollY(v));
  }, [scrollY]);

  useEffect(() => {
    const detectSectionDimension = () => {
      const headSectionEl = headSectionRef.current as unknown as HTMLDivElement;
      const introSectionEl = introSectionRef.current as unknown as HTMLDivElement;
      const backgroundSectionEl = backgroundSectionRef.current as unknown as HTMLDivElement;
      const effortSectionEl = effortSectionRef.current as unknown as HTMLDivElement;
      const effectSectionEl = effectSectionRef.current as unknown as HTMLDivElement;
      const highlightSectionEl = highlightSectionRef.current as unknown as HTMLDivElement;
      const caseStudySectionEl = caseStudySectionRef.current as unknown as HTMLDivElement;

      if (headSectionEl) {
        const rect = headSectionEl.getBoundingClientRect();
        sectionDimensions.head = rect.height;
      }
      if (introSectionEl) {
        const rect = introSectionEl.getBoundingClientRect();
        sectionDimensions.intro = rect.height;
      }
      if (backgroundSectionEl) {
        const rect = backgroundSectionEl.getBoundingClientRect();
        sectionDimensions.background = rect.height;
      }
      if (effortSectionEl) {
        const rect = effortSectionEl.getBoundingClientRect();
        sectionDimensions.effort = rect.height;
      }
      if (effectSectionEl) {
        const rect = effectSectionEl.getBoundingClientRect();
        sectionDimensions.effect = rect.height;
      }
      if (highlightSectionEl) {
        const rect = highlightSectionEl.getBoundingClientRect();
        sectionDimensions.highlight = rect.height;
      }
      if (caseStudySectionEl) {
        const rect = caseStudySectionEl.getBoundingClientRect();
        sectionDimensions.caseStudy = rect.height;
      }
      setSectionDimensions(sectionDimensions);
    };

    const handleResize = () => {
      detectSectionDimension();
    };

    detectSectionDimension();

    if (window) {
      window.addEventListener('resize', handleResize);
    }
    return () => {
      if (window) {
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [sectionDimensions]);

  const headParallaxScrollRange = [0, sectionDimensions.caseStudy];
  const headParallax = {
    heading: useTransform(scrollY, headParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    content: useTransform(scrollY, headParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    image: useTransform(scrollY, headParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    imageText: useTransform(scrollY, headParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
  };
  const headVariants: any = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    image: {
      enter: {
        opacity: 1,
        transition: {
          duration: 0.5,
        },
      },
      exit: {
        opacity: 0,
      },
    },
    item: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
          delay: 0.5,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  // const introParallaxScrollRange = [headParallaxScrollRange[0], headParallaxScrollRange[1] + sectionDimensions.intro];
  const introVariants: any = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    item: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
    solution: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
        transition: {
          staggerChildren: 0.05,
          staggerDirection: -1,
        },
      },
    },
  };
  /* const backgroundParallaxScrollRange = [
    introParallaxScrollRange[0],
    introParallaxScrollRange[1] + sectionDimensions.background,
  ]; */
  const backgroundVariants = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    graphic: {
      enter: {
        opacity: 1,
        x: isSP ? -724 : -1244,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        x: isSP ? -724 : -1244,
      },
    },
    graphic2: {
      enter: {
        opacity: 1,
        x: isSP ? -70 : 448,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        x: isSP ? -70 : 448,
      },
    },
    content: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          // staggerChildren: 0.25,
          delayChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
        transition: {
          staggerChildren: 0.05,
          staggerDirection: -1,
        },
      },
    },
    item: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
          delay: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  /* const effortParallaxScrollRange = [
    backgroundParallaxScrollRange[0],
    backgroundParallaxScrollRange[1] + sectionDimensions.effort,
  ]; */
  const effortVariants = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    content: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
        transition: {
          staggerChildren: 0.05,
          staggerDirection: -1,
        },
      },
    },
    item: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  /* const effectParallaxScrollRange = [
    effortParallaxScrollRange[0],
    effortParallaxScrollRange[1] + sectionDimensions.effect,
  ]; */
  const effectVariants = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    content: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          staggerChildren: 0.25,
          delayChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
        transition: {
          staggerChildren: 0.05,
          staggerDirection: -1,
        },
      },
    },
    item: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  /* const highlightParallaxScrollRange = [
    effectParallaxScrollRange[0],
    effectParallaxScrollRange[1] + sectionDimensions.highlight,
  ]; */
  const highlightVariants = {
    root: {
      enter: {
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 },
      },
    },
    /* bg: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 3,
          ease: EASING_VALUE,
        },
      },
      exit: {
        opacity: 0,
        y: 40,
      },
    }, */
    circle: {
      enter: {
        scale: 1,
        transition: {
          duration: 1.5,
        },
      },
      exit: {
        scale: 0,
      },
    },
    logo: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 3,
          ease: EASING_VALUE,
          delay: 0.5,
        },
      },
      exit: {
        opacity: 0,
        y: 40,
      },
    },
    content: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          staggerChildren: 0.25,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
        transition: {
          staggerChildren: 0.05,
          staggerDirection: -1,
        },
      },
    },
    item: {
      enter: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 1.5,
          ease: EASING_VALUE,
          delay: 2,
        },
      },
      exit: {
        opacity: 0,
        y: 10,
      },
    },
  };
  /* const caseStudyParallaxScrollRange = [
    highlightParallaxScrollRange[0],
    highlightParallaxScrollRange[1] + sectionDimensions.caseStudy,
  ];
  const caseStudyParallax = {
    heading: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    content: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    image: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
    imageText: useTransform(scrollY, caseStudyParallaxScrollRange, isSP ? [0, 0] : [0, 0]),
  };
  const caseStudyVariants = isSP ? CASE_STUDY_VARIANTS_SP : CASE_STUDY_VARIANTS; */

  return (
    <Layout pageId="/case-study">
      <NextSeo
        title={PAGE_SEO_INFO.title}
        description={PAGE_SEO_INFO.description}
        openGraph={{
          type: 'website',
          url: PAGE_URL,
          title: PAGE_SEO_INFO.title,
          description: PAGE_SEO_INFO.description,
          site_name: SEO_INFO.HOME.title,
        }}
        // additionalLinkTags={preloadList}
      />
      <div className="p-case-study">
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            zIndex: 9999,
            color: 'red',
            display: 'none',
          }}
        >
          {pageScrollY} {JSON.stringify(sectionDimensions)}
        </div>
        {/* <!-- CASE STUDY --> */}
        <InView threshold={0.1} triggerOnce>
          {({ inView, ref }) => (
            <section ref={headSectionRef} className="p-case-study__head">
              <motion.div
                ref={ref}
                className="o-section-case-study"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={headVariants.root}
              >
                <Container>
                  <Row>
                    <Col className="o-section-case-study__heading-col" width={1} widthSP={4}></Col>
                    <Col className="o-section-case-study__text-col" width={5} widthSP={4}>
                      <motion.div
                        className="o-section-case-study__heading"
                        variants={headVariants.item}
                        style={{ y: headParallax.heading }}
                      >
                        <Heading modifiers="dot" size="large">
                          Case Study
                        </Heading>
                      </motion.div>
                      <motion.div className="o-section-case-study__text" style={{ y: headParallax.content }}>
                        <motion.h1 className="o-section-case-study__text-title" variants={headVariants.item}>
                          Contributing
                          <br />
                          to Advancement
                        </motion.h1>
                        <motion.p className="o-section-case-study__text-subtitle" variants={headVariants.item}>
                          An ASEAN Country
                        </motion.p>
                      </motion.div>
                    </Col>
                    <Col className="o-section-case-study__image-col" width={6} widthSP={4}>
                      <div className="o-section-case-study__image">
                        <motion.figure
                          className="o-section-case-study__image-item"
                          variants={headVariants.image}
                          style={{ y: headParallax.image }}
                        >
                          <MaskImage
                            start={inView}
                            video={
                              <video muted={true} playsInline={true}>
                                <source type="video/webm" src="/videos/mask.webm" />
                                <source type="video/mp4" src="/videos/mask.mp4" />
                              </video>
                            }
                          >
                            <picture>
                              <source
                                type="image/jpg"
                                media="(max-width: 768px)"
                                srcSet="/images/home/case-study-sp.jpg, /images/home/case-study-sp@2x.jpg 2x"
                              />
                              <source
                                type="image/jpg"
                                media="(min-width: 769px)"
                                srcSet="/images/home/case-study.jpg, /images/home/case-study@2x.jpg 2x"
                              />
                              <source
                                type="image/webp"
                                media="(max-width: 768px)"
                                srcSet="/images/home/case-study-sp.jpg, /images/home/case-study-sp@2x.webp 2x"
                              />
                              <source
                                type="image/webp"
                                media="(min-width: 769px)"
                                srcSet="/images/home/case-study.webp, /images/home/case-study@2x.webp 2x"
                              />
                              <img
                                src="/images/home/case-study.jpg"
                                srcSet="/images/home/case-study.jpg, /images/home/case-study@2x.jpg 2x"
                                alt="Case Study"
                                width="375"
                                height="420"
                              />
                            </picture>
                          </MaskImage>
                        </motion.figure>
                        <motion.i
                          className="o-section-case-study__image-text"
                          variants={headVariants.item}
                          style={{ y: headParallax.imageText }}
                        >
                          C
                        </motion.i>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </motion.div>
            </section>
          )}
        </InView>
        {/* <!-- /CASE STUDY --> */}

        <InView threshold={0.1} triggerOnce>
          {({ inView, ref }) => (
            <section ref={introSectionRef} className="p-case-study__intro">
              <motion.div
                ref={ref}
                className="p-case-study__intro-wrapper"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={introVariants.root}
              >
                <Container>
                  <Row>
                    <Col width={1} widthSP={4}></Col>
                    <Col width={10} widthSP={4}>
                      <motion.div className="p-case-study__intro-text" variants={introVariants.item}>
                        The implementation of “v-PaSSer” has promoted to advanced digital payment and settlement, made
                        formal remittance services more accessible. It also contributes to the financial inclusion.
                      </motion.div>
                      <motion.div className="p-case-study__intro-solution" variants={introVariants.solution}>
                        <motion.div className="p-case-study__intro-solution-title" variants={introVariants.item}>
                          SOLUTION
                        </motion.div>
                        <motion.div className="p-case-study__intro-solution-links" variants={introVariants.solution}>
                          {relatedProducts.map((item, index) => (
                            <Link key={index} href={`/products-list/${item.slug}`}>
                              <motion.a
                                className="p-case-study__intro-solution-link"
                                href={`/products-list/${item.slug}`}
                                variants={introVariants.item}
                              >
                                {item.title}
                              </motion.a>
                            </Link>
                          ))}
                        </motion.div>
                      </motion.div>
                    </Col>
                    <Col width={1} widthSP={4}></Col>
                  </Row>
                </Container>
              </motion.div>
            </section>
          )}
        </InView>

        <InView threshold={0.1} triggerOnce>
          {({ inView, ref }) => (
            <section ref={backgroundSectionRef} className="p-case-study__background">
              <motion.div
                ref={ref}
                className="p-case-study__background-wrapper"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={backgroundVariants.root}
              >
                <motion.div
                  className="p-case-study__background-graphic p-case-study__background-graphic--1"
                  variants={backgroundVariants.graphic}
                >
                  <svg width="823.69" height="1198.009" viewBox="0 0 823.69 1198.009">
                    <g id="Group_26458" data-name="Group 26458" transform="translate(-115.912 1000.295) rotate(-75)">
                      <path
                        id="Path_22315"
                        data-name="Path 22315"
                        d="M85.835,68.958,103.043,0S49.912,21.68,0,46.188Z"
                        transform="translate(939.932 86.446)"
                        fill="#001e42"
                      />
                      <path
                        id="Path_22316"
                        data-name="Path 22316"
                        d="M126.39,0S90.516,63.444,72.338,99.535L0,97.42Z"
                        transform="translate(972.291 235.492)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22317"
                        data-name="Path 22317"
                        d="M153.134,64.325,120.279,0,0,109.273Z"
                        transform="translate(809.015 113.885)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22319"
                        data-name="Path 22319"
                        d="M62.15,0,0,111S64.455,41.534,97.769,15.07Z"
                        transform="translate(113.593 587.128)"
                        fill="#df1f1c"
                      />
                      <path
                        id="Path_22320"
                        data-name="Path 22320"
                        d="M236.175,71.447,270.98,0S109.818,67.2,0,129.381Z"
                        transform="translate(603.956 75.475)"
                        fill="#001976"
                      />
                      <path
                        id="Path_22321"
                        data-name="Path 22321"
                        d="M188.821,0,0,62.665,142.959,82.273Z"
                        transform="translate(689.851 274.551)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22322"
                        data-name="Path 22322"
                        d="M252.516,0l-70.56,125.523L0,65.41Z"
                        transform="translate(606.093 173.552) rotate(42)"
                        fill="#8ea7cd"
                      />
                      <path
                        id="Path_22323"
                        data-name="Path 22323"
                        d="M109.541,0A1156.348,1156.348,0,0,0,0,84.974L252.512,19.609Z"
                        transform="translate(372.862 116.192)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22324"
                        data-name="Path 22324"
                        d="M108.324,0,0,89.5l290.316-29.3Z"
                        transform="translate(298.096 193.637)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22325"
                        data-name="Path 22325"
                        d="M217.712,0s-60.764,72.985-78.772,101.034L0,22Z"
                        transform="translate(474.458 564.053)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22326"
                        data-name="Path 22326"
                        d="M149.94,80.855,91.9,0,0,177.62S81.488,119,149.94,80.855Z"
                        transform="translate(618.707 426.481)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22327"
                        data-name="Path 22327"
                        d="M89.617,0,0,81.874,81.521,199.822Z"
                        transform="translate(282.185 449.729)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22328"
                        data-name="Path 22328"
                        d="M166.562,46.573,86.745,0S25.9,55.616,0,82.309l93.882,31.527Z"
                        transform="translate(267.417 345.128)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22329"
                        data-name="Path 22329"
                        d="M202.178,0,0,58.408l218.5,84.041Z"
                        transform="translate(207.814 671.006)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22330"
                        data-name="Path 22330"
                        d="M152.39,67.507,90.74,0,0,108.248Z"
                        transform="translate(-49.169 472.158)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22331"
                        data-name="Path 22331"
                        d="M0,0,61.626,172.466s99.987-128,130.936-158.084Z"
                        transform="translate(123.507 86.907)"
                        fill="#8ea7cd"
                      />
                      <path
                        id="Path_22332"
                        data-name="Path 22332"
                        d="M9.784,0,0,108.723l124.159,81.583Z"
                        transform="translate(178.939 701.227)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22333"
                        data-name="Path 22333"
                        d="M205.4,0,0,43.5,115.779,81.864Z"
                        transform="translate(56.865 328.826)"
                        fill="#df1f1c"
                      />
                      <ellipse
                        id="Ellipse_3085"
                        data-name="Ellipse 3085"
                        cx="81.883"
                        cy="81.884"
                        rx="81.883"
                        ry="81.884"
                        transform="translate(495.922 244.258)"
                        fill="#df1f1c"
                      />
                      <ellipse
                        id="Ellipse_3088"
                        data-name="Ellipse 3088"
                        cx="83.373"
                        cy="83.373"
                        rx="83.373"
                        ry="83.373"
                        transform="translate(361.475 471.205)"
                        fill="#001976"
                      />
                    </g>
                  </svg>
                </motion.div>
                <motion.div
                  className="p-case-study__background-graphic p-case-study__background-graphic--2"
                  variants={backgroundVariants.graphic2}
                >
                  <svg width="718.671" height="912.235" viewBox="0 0 718.671 912.235">
                    <g id="Group_25729" data-name="Group 25729" transform="translate(-197.298 837.577) rotate(-75)">
                      <path
                        id="Path_22315"
                        data-name="Path 22315"
                        d="M81.753,65.678,98.142,0S47.538,20.648,0,43.991Z"
                        transform="translate(825.259 244.33)"
                        fill="#001e42"
                      />
                      <path
                        id="Path_22316"
                        data-name="Path 22316"
                        d="M120.378,0S86.211,60.426,68.9,94.8L0,92.786Z"
                        transform="translate(786.711 202.81)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22317"
                        data-name="Path 22317"
                        d="M145.85,61.265,114.558,0,0,104.075Z"
                        transform="translate(751.299 112.058)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22319"
                        data-name="Path 22319"
                        d="M59.194,0,0,105.723s61.389-66.165,93.118-91.37Z"
                        transform="translate(808.239 322.911)"
                        fill="#df1f1c"
                      />
                      <path
                        id="Path_22320"
                        data-name="Path 22320"
                        d="M224.941,68.048,258.09,0S104.594,64.006,0,123.227Z"
                        transform="translate(555.994 75.475)"
                        fill="#001976"
                      />
                      <path
                        id="Path_22321"
                        data-name="Path 22321"
                        d="M179.84,0,0,59.684,136.159,78.36Z"
                        transform="translate(637.803 265.082)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22322"
                        data-name="Path 22322"
                        d="M240.505,0,173.3,119.552,0,62.3Z"
                        transform="translate(558.03 168.887) rotate(42)"
                        fill="#8ea7cd"
                      />
                      <path
                        id="Path_22323"
                        data-name="Path 22323"
                        d="M104.331,0A1101.348,1101.348,0,0,0,0,80.932L240.5,18.676Z"
                        transform="translate(335.892 114.256)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22324"
                        data-name="Path 22324"
                        d="M103.172,0,0,85.241l276.507-27.91Z"
                        transform="translate(264.682 188.016)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22325"
                        data-name="Path 22325"
                        d="M207.356,0s-57.873,69.513-75.025,96.229L0,20.957Z"
                        transform="translate(453.745 567.717)"
                        fill="#ffe900"
                      />
                      <path
                        id="Path_22326"
                        data-name="Path 22326"
                        d="M142.808,77.01,87.528,0,0,169.171S77.612,113.34,142.808,77.01Z"
                        transform="translate(468.836 615.219)"
                        fill="#0092e5"
                      />
                      <path
                        id="Path_22327"
                        data-name="Path 22327"
                        d="M85.354,0,0,77.979,77.644,190.317Z"
                        transform="translate(249.528 431.928)"
                        fill="#fca518"
                      />
                      <path
                        id="Path_22328"
                        data-name="Path 22328"
                        d="M158.639,44.358,82.619,0S24.666,52.97,0,78.394l89.417,30.027Z"
                        transform="translate(272.53 345.244)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22329"
                        data-name="Path 22329"
                        d="M192.561,0,0,55.629l208.105,80.043Z"
                        transform="translate(178.695 642.679)"
                        fill="#cbdae9"
                        opacity="0.6"
                      />
                      <path
                        id="Path_22332"
                        data-name="Path 22332"
                        d="M9.318,0,0,103.551l118.254,77.7Z"
                        transform="translate(151.193 671.463)"
                        fill="#0092e5"
                      />
                      <ellipse
                        id="Ellipse_3085"
                        data-name="Ellipse 3085"
                        cx="77.989"
                        cy="77.989"
                        rx="77.989"
                        ry="77.989"
                        transform="translate(453.099 236.23)"
                        fill="#df1f1c"
                      />
                      <ellipse
                        id="Ellipse_3088"
                        data-name="Ellipse 3088"
                        cx="79.407"
                        cy="79.407"
                        rx="79.407"
                        ry="79.407"
                        transform="translate(325.047 452.382)"
                        fill="#001976"
                      />
                    </g>
                  </svg>
                </motion.div>
                <div className="p-case-study__background-bg"></div>
                <motion.div className="p-case-study__background-content" variants={backgroundVariants.content}>
                  <Container>
                    <Row>
                      <Col width={2} widthSP={4}></Col>
                      <Col width={8} widthSP={4}>
                        <motion.div className="p-case-study__background-title" variants={backgroundVariants.item}>
                          Background
                        </motion.div>
                      </Col>
                      <Col width={2} widthSP={4}></Col>
                    </Row>
                    <Row>
                      <Col width={3} widthSP={4}></Col>
                      <Col width={6} widthSP={4}>
                        <motion.div className="p-case-study__background-summary" variants={backgroundVariants.item}>
                          Society’s demand for the payment & settlement infrastructure that facilitates the use of
                          secure, convenient, and formal digital payments in an ASEAN country.
                        </motion.div>
                      </Col>
                      <Col width={3} widthSP={4}></Col>
                    </Row>
                    <Row>
                      <Col width={2} widthSP={4}></Col>
                      <Col width={8} widthSP={4}>
                        <motion.ul className="p-case-study__background-list" variants={backgroundVariants.content}>
                          <motion.li className="p-case-study__background-item" variants={backgroundVariants.item}>
                            While RTGS and CSD have been implemented to interbank payment and settlement operations to
                            modernize financial systems, financial institutes have been gradually implementing new
                            technologies and services such as core banking systems and mobile banking and payments. Even
                            so, the retail payment and settlement infrastructure, which allows transfers between
                            accounts at the same financial institution but not to other banks, was not yet fully
                            developed, and there was a need to further improve the payment & settlement infrastructure
                            to catch up with technological innovation.
                          </motion.li>
                          <motion.li className="p-case-study__background-item" variants={backgroundVariants.item}>
                            In addition, the percentage of domestic payment account holders remained low, and the use of
                            payment methods that lacked convenience and security, such as cash and informal payments,
                            continued.
                          </motion.li>
                        </motion.ul>
                      </Col>
                      <Col width={2} widthSP={4}></Col>
                    </Row>
                  </Container>
                </motion.div>
              </motion.div>
            </section>
          )}
        </InView>

        <InView threshold={0.1} triggerOnce>
          {({ inView, ref }) => (
            <section ref={effortSectionRef} className="p-case-study__effort">
              <motion.div
                ref={ref}
                className="p-case-study__effort-wrapper"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={effortVariants.root}
              >
                <Container>
                  <Row>
                    <Col width={12} widthSP={4}>
                      <motion.div className="p-case-study__effort-title" variants={effortVariants.item}>
                        Effort
                      </motion.div>
                    </Col>
                  </Row>
                </Container>
                <motion.div className="p-case-study__effort-list" variants={effortVariants.content}>
                  {effortList.map((item, index) => (
                    <InView threshold={0.1} key={index} triggerOnce>
                      {({ inView: cInView, ref: cRef }) => (
                        <motion.div
                          ref={cRef}
                          className={mapModifiers('p-case-study__effort-item', index.toString())}
                          initial={false}
                          animate={cInView ? 'enter' : 'exit'}
                          variants={effortVariants.item}
                        >
                          <motion.div className="p-case-study__effort-content" variants={effortVariants.content}>
                            <Container>
                              <Row key={index}>
                                <Col className="p-case-study__effort-image-col" width={6} widthSP={4}>
                                  <motion.div
                                    className="p-case-study__effort-image-holder"
                                    variants={effortVariants.item}
                                  >
                                    <picture>
                                      <source type="image/svg+xml" media="(max-width: 768px)" srcSet={item.imageSP} />
                                      <source type="image/svg+xml" media="(min-width: 769px)" srcSet={item.image} />
                                      <img
                                        className="p-case-study__effort-image"
                                        src={item.image}
                                        width="598"
                                        height="337"
                                        alt={item.title}
                                      />
                                    </picture>
                                  </motion.div>
                                </Col>
                                <Col width={1} widthSP={4}></Col>
                                <Col width={5} widthSP={4}>
                                  <motion.div
                                    className="p-case-study__effort-content"
                                    variants={effortVariants.content}
                                  >
                                    <motion.div className="p-case-study__effort-text" variants={effortVariants.item}>
                                      {item.title}
                                    </motion.div>
                                    <motion.ul
                                      className="p-case-study__effort-detail"
                                      variants={effortVariants.content}
                                    >
                                      {item.items.map((cItem: string, cIndex: number) => (
                                        <motion.li key={cIndex} variants={effortVariants.item}>
                                          {cItem}
                                        </motion.li>
                                      ))}
                                    </motion.ul>
                                  </motion.div>
                                </Col>
                              </Row>
                            </Container>
                          </motion.div>
                        </motion.div>
                      )}
                    </InView>
                  ))}
                </motion.div>
              </motion.div>
            </section>
          )}
        </InView>

        <InView threshold={0.1} triggerOnce>
          {({ inView, ref }) => (
            <section ref={effectSectionRef} className="p-case-study__effect">
              <motion.div
                ref={ref}
                className="p-case-study__effect-wrapper"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={effectVariants.root}
              >
                <motion.div className="p-case-study__effect-top" variants={effectVariants.content}>
                  <Container>
                    <Row>
                      <Col width={2} widthSP={4}></Col>
                      <Col width={8} widthSP={4}>
                        <motion.div className="p-case-study__effect-title" variants={effectVariants.item}>
                          Effect
                        </motion.div>
                        <motion.div className="p-case-study__effect-summary" variants={effectVariants.item}>
                          Made It Possible That Real-time 24-hour Remittance between Different banks, and Dramatically
                          Improving the Convenience of Remittances.
                        </motion.div>
                        <motion.div className="p-case-study__effect-summary-2" variants={effectVariants.item}>
                          This has been achieved by building on the respective effectiveness of the central bank and
                          financial institutes.
                        </motion.div>
                      </Col>
                      <Col width={2} widthSP={4}></Col>
                    </Row>
                  </Container>
                </motion.div>
                <div className="p-case-study__effect-list">
                  {effectList.map((item, index) => (
                    <InView threshold={0.1} key={index} triggerOnce>
                      {({ inView: cInView, ref: cRef }) => (
                        <motion.div
                          ref={cRef}
                          className="p-case-study__effect-item"
                          initial={false}
                          animate={cInView ? 'enter' : 'exit'}
                          variants={effectVariants.content}
                        >
                          <Container>
                            <Row>
                              <Col className="p-case-study__effect-image-col" width={6} widthSP={4}>
                                <motion.div
                                  className="p-case-study__effect-image-holder"
                                  variants={effectVariants.item}
                                >
                                  <picture>
                                    <source type="image/svg+xml" media="(max-width: 768px)" srcSet={item.imageSP} />
                                    <source type="image/svg+xml" media="(min-width: 769px)" srcSet={item.image} />
                                    <img
                                      className="p-case-study__effect-image"
                                      src={item.image}
                                      width="598"
                                      height="337"
                                      alt={item.title}
                                    />
                                  </picture>
                                </motion.div>
                              </Col>
                              <Col width={1} widthSP={4}></Col>
                              <Col width={5} widthSP={4}>
                                <motion.div className="p-case-study__effect-content" variants={effectVariants.content}>
                                  <motion.div className="p-case-study__effect-text" variants={effectVariants.item}>
                                    {item.title}
                                  </motion.div>
                                  <motion.div
                                    className="p-case-study__effect-description"
                                    dangerouslySetInnerHTML={{
                                      __html: item.description,
                                    }}
                                    variants={effectVariants.item}
                                  />
                                </motion.div>
                              </Col>
                            </Row>
                          </Container>
                        </motion.div>
                      )}
                    </InView>
                  ))}
                </div>
              </motion.div>
            </section>
          )}
        </InView>

        <InView threshold={0.1} triggerOnce>
          {({ inView, ref }) => (
            <section ref={highlightSectionRef} className="p-case-study__highlight">
              <motion.div
                ref={ref}
                className="p-case-study__highlight-wrapper"
                initial={false}
                animate={inView ? 'enter' : 'exit'}
                variants={highlightVariants.root}
              >
                <motion.div className="p-case-study__highlight-bg">
                  <svg width="3426.521" height="3433.139" viewBox="0 0 3426.521 3433.139">
                    <motion.ellipse
                      data-name="Ellipse 3287"
                      cx="1713.26"
                      cy="1716.569"
                      rx="1713.26"
                      ry="1716.569"
                      fill="#df1f1c"
                      variants={highlightVariants.circle}
                    />
                  </svg>
                </motion.div>
                <motion.div className="p-case-study__highlight-icon" variants={highlightVariants.logo}>
                  <img src="/images/logos/graph.svg" width="120" height="120" alt="For Future" />
                </motion.div>
                <motion.div className="p-case-study__highlight-content" variants={highlightVariants.content}>
                  <Container>
                    <Row>
                      <Col width={2} widthSP={4}></Col>
                      <Col width={8} widthSP={4}>
                        <motion.div className="p-case-study__highlight-title" variants={highlightVariants.item}>
                          For Future
                        </motion.div>
                        <motion.div className="p-case-study__highlight-description" variants={highlightVariants.item}>
                          In addition, interoperability has been realized by implementing ISO20022. This reduces the
                          social cost of connecting to the payment & settlement system and provides a wide range of
                          users with access to formal financial services.
                        </motion.div>
                      </Col>
                      <Col width={2} widthSP={4}></Col>
                    </Row>
                  </Container>
                </motion.div>
              </motion.div>
            </section>
          )}
        </InView>

        <section className="p-service-list__back">
          <BackButton path="/" />
        </section>
      </div>
    </Layout>
  );
};

export default withRouter(CaseStudyPage);
